import { InputLabel, InputProps, Typography } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { FC } from 'react'
import { DropdownOption } from 'shared/models/dropdownOption'
import { fontSize } from 'shared/style/constants'
import { getPxAsRem } from 'shared/utils'

interface ToggleEditSelectFieldProps {
    edit: boolean
    disabled?: boolean
    label: string
    labelId: string
    selectedDropdownData: DropdownOption[] | undefined
    dropdownData: DropdownOption[]
    isDisabled?: boolean
    onInputChange: (arg: DropdownOption[]) => void
    limit: number
    InputProps?: Partial<InputProps>
    hideLabel?: boolean
}
const ToggleEditMultiSelectField: FC<ToggleEditSelectFieldProps> = ({
    edit,
    label,
    labelId,
    dropdownData,
    selectedDropdownData,
    onInputChange,
    limit,
    InputProps,
    hideLabel = false,
}) => {
    let dataList = selectedDropdownData?.map((item) => item.value) || []

    const isOptionsDisabled = (option, selectedDropdownData): boolean => {
        return (
            selectedDropdownData?.length >= limit &&
            !selectedDropdownData.some((item) => item.value === option.value)
        )
    }

    if (edit)
        return (
            <Autocomplete
                multiple
                fullWidth
                id={labelId}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                    if (newValue.length <= limit) onInputChange(newValue)
                }}
                value={selectedDropdownData}
                options={dropdownData}
                getOptionLabel={(option) => option.value}
                style={{ marginBottom: getPxAsRem(16) }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={hideLabel ? '' : label}
                        placeholder=""
                        InputProps={{
                            ...params.InputProps,
                            ...InputProps,
                            sx: {
                                padding: `${getPxAsRem(9, 65, 9, 6)} !important`,
                                ...InputProps?.sx,
                            },
                        }}
                    />
                )}
                getOptionDisabled={(option) =>
                    isOptionsDisabled(option, selectedDropdownData)
                }
            />
        )
    return (
        <>
            {hideLabel ? (
                <></>
            ) : (
                <InputLabel sx={{ fontSize: fontSize.xsmall }}>
                    {label}
                </InputLabel>
            )}
            <Typography variant="body1">
                {dataList.map(String).join(', ') || '-'}
            </Typography>
        </>
    )
}

export default ToggleEditMultiSelectField
